import { useStore } from "@dp/state";
import { useBreakpointValue } from "native-base";
export var headerHeightByBreakpoint = {
  base: "77px",
  md: "91px"
};
export function useHeaderHeight() {
  // Removed store usage because it is giving undefined in the start causing layout issues
  // i18next.exists giving true for empty strings also. So had to use !!
  var store = useStore();
  var globalBannerMessage = store.common.shouldShowGlobalBanner;
  return useBreakpointValue({
    base: globalBannerMessage ? "115px" : "77px",
    md: globalBannerMessage ? "131px" : "91px"
  });
}